// extracted by mini-css-extract-plugin
export default {"BlankSpace":"BlankSpace_BlankSpace__htEA5"};